export default "__VITE_ASSET__DXLGP7e$__"